module.exports = new __parcel__URL__("bin.a4ae3936.svg").toString();